const schoolAffairs = {
    namespaced: true,
    state: {
      visitorInfo: {}
    },
    mutations: {
        setVisitorInfo(state, visitorInfo) {
        state.visitorInfo = visitorInfo
      }
    },
  }
  export default schoolAffairs